import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase/firebase';
import { CSVLink } from 'react-csv';
import '../assets/css/CourseApplicantsPage.css';

const CourseApplicationsPage = ({ courseName }) => {
    const [applicants, setApplicants] = useState([]);

    useEffect(() => {
        const fetchApplicants = async () => {
            try {
                const snapshot = await firestore
                    .collection('Registrations')
                    .where('course', '==', courseName)
                    .where('submitted', '==', true)
                    .get();

                const applicantsData = snapshot.docs.map((doc, index) => {
                    const data = doc.data();
                    return {
                        ...data,
                        number: index + 1 // Add row number starting from 1
                    };
                });
                setApplicants(applicantsData);
            } catch (error) {
                console.error('Error fetching applicants:', error);
            }
        };

        fetchApplicants();
    }, [courseName]);

    const convertAllToCSV = () => {
        const csvData = applicants.map((applicant) => {
            const rowData = {
                Number: applicant.number,
                Name: applicant.name,
                Phone: applicant.phone,
                RRR: applicant.rrr,
                Status: applicant.status,
                AppNo: applicant.courseForm?.appNo || '',
                Email: applicant.courseForm?.email || '',
                DateSubmitted: applicant.courseForm?.DateSubmitted?.toDate?.() || '',
                Address: applicant.courseForm?.address || '',
                Curricular: applicant.courseForm?.curricular || '',
                Denomination: applicant.courseForm?.denomination || '',
                DOB: applicant.courseForm?.dob || '',
                Gender: applicant.courseForm?.gender || '',
                Kin: applicant.courseForm?.kin || '',
                LastName: applicant.courseForm?.lastName || '',
                LocalGov: applicant.courseForm?.localGov || '',
                MaidenName: applicant.courseForm?.maidenName || '',
                MaritalStatus: applicant.courseForm?.maritalStatus || '',
                MiddleName: applicant.courseForm?.middleName || '',
                Nationality: applicant.courseForm?.nationality || '',
                NOKAddress: applicant.courseForm?.nokAddress || '',
                NOKPhone: applicant.courseForm?.nokPhone || '',
                Passport: applicant.courseForm?.passport || '',
                Religion: applicant.courseForm?.religion || '',
                State: applicant.courseForm?.state || '',
                JambRegistrationNumber: applicant.courseForm?.registrationNumber || '',
                JambExaminationNumber: applicant.courseForm?.examinationNumber || '',
                JambYearOfExamination: applicant.courseForm?.yearOfExamination || '',
                JambExaminationScore: applicant.courseForm?.examinationScore || ''
            };

            (applicant.courseForm?.education || []).forEach((edu, index) => {
                rowData[`Education_Type_${index + 1}`] = edu.type || '';
                rowData[`Education_From_${index + 1}`] = edu.from || '';
                rowData[`Education_To_${index + 1}`] = edu.to || '';
                rowData[`Education_Others_${index + 1}`] = edu.others || '';
            });

            (applicant.courseForm?.subjects || []).forEach((sub, index) => {
                rowData[`Subject_${index + 1}`] = sub.details || '';
                rowData[`Subject_${index + 1}_Name`] = sub.sub1 || '';
                rowData[`Grade_${index + 1}`] = sub.grade1 || '';
                rowData[`Subject_${index + 2}_Name`] = sub.sub2 || '';
                rowData[`Grade_${index + 2}`] = sub.grade2 || '';
                rowData[`Subject_${index + 3}_Name`] = sub.sub3 || '';
                rowData[`Grade_${index + 3}`] = sub.grade3 || '';
                rowData[`Subject_${index + 4}_Name`] = sub.sub4 || '';
                rowData[`Grade_${index + 4}`] = sub.grade4 || '';
                rowData[`Subject_${index + 5}_Name`] = sub.sub5 || '';
                rowData[`Grade_${index + 5}`] = sub.grade5 || '';
            });

            return rowData;
        });

        console.log('CSV Data:', csvData); // Log the entire CSV data array

        return csvData;
    };


    return (
        <div className="course-applications-container">
            <div className="course-header">
                <h3>{courseName}</h3>
                <CSVLink
                    data={convertAllToCSV()}
                    filename={`applicants_${courseName}.csv`}
                    className="export-button"
                >
                    Export All to CSV
                </CSVLink>
            </div>
            <table className="applicants-table">
                <thead>
                    <tr>
                        <th>Number</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>RRR</th>
                        <th>Status</th>
                        <th>App No</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    {applicants.map((applicant) => (
                        <tr key={applicant.number}>
                            <td>{applicant.number}</td>
                            <td>{applicant.name}</td>
                            <td>{applicant.phone}</td>
                            <td>{applicant.rrr}</td>
                            <td>{applicant.status}</td>
                            <td>{applicant.courseForm?.appNo || ''}</td>
                            <td>{applicant.courseForm?.email || ''}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CourseApplicationsPage;
